/**
 * Social Gallery Logo — camera aperture, rendered with lucide-react's
 * `Aperture` so the six shutter blades stay razor-crisp at small nav scales.
 * A tiny "viewfinder LED" dot sits at 1-o'clock, nudging it away from the
 * generic icon. Colour follows `text-*` (see `text-sienna-400` in Navbar).
 */
import { Aperture } from "lucide-react";

export default function Logo({ size = 40, className = "" }) {
  return (
    <span
      className={`relative inline-flex ${className}`}
      aria-label="Social Gallery"
      data-testid="app-logo"
    >
      <Aperture size={size} strokeWidth={1.4} />
      <span
        className="absolute right-0 top-0 h-1.5 w-1.5 rounded-full bg-current"
        aria-hidden
      />
    </span>
  );
}
